import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useRole } from '../../contexts/RoleContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const RoleRoute = ({ children, requiredRole, requiredPermission }) => {
  const { currentUser, loading: authLoading } = useAuth();
  const { hasRole, hasPermission, loading: roleLoading } = useRole();

  // Show loading state while checking authentication and role
  if (authLoading || roleLoading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          justifyContent: 'center',
          minHeight: '60vh'
        }}
      >
        <CircularProgress sx={{ color: '#1B5E20' }} />
        <Typography variant="body1" sx={{ mt: 2, color: '#1B5E20' }}>
          Checking permissions...
        </Typography>
      </Box>
    );
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Check role and permission requirements
  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to="/unauthorized" />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default RoleRoute; 